module.exports = __webpack_public_path__ + "img/oneOrange.74cea1f2.jpg";